import { useCallback } from 'react'
import { useTrackChannelBackfillDone } from '~/shared/hooks/tracking'
import { updateChannel } from '~/modules/account/utils'
import { useChannels } from '~/app/state/hooks'
import { usePostsContext } from '~/modules/post/context'

/**
 *
 */
export default function useEventBackfillDone() {
  const { getChannels, mutateChannels } = useChannels()
  const trackChannelBackfillDone = useTrackChannelBackfillDone()

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const [_, { refetch: refetchPosts }] = usePostsContext()

  return useCallback(
    ({
      channelId,
      emojis,
      backfillStartedAt,
    }: {
      channelId: any
      emojis: any
      backfillStartedAt: any
    }) => {
      const channels = getChannels()

      const updatedChannels = updateChannel(channels, channelId, {
        backfillingComplete: true,
        emojis,
      })

      if (!updatedChannels) {
        return
      }

      // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
      const channel = updatedChannels.find((el) => el.id === channelId)
      if (channel) {
        const backfillEndedAt = new Date().getTime()
        const backfill = {
          backfillDuration: backfillEndedAt - backfillStartedAt,
          backfillEndedAt,
          backfillStartedAt,
        }

        trackChannelBackfillDone(channel, backfill)
      }

      mutateChannels(updatedChannels)
      refetchPosts()
    },
    [refetchPosts],
  )
}
